import Slider from '../src/slider';
import 'jquery';
import 'gsap';
import 'ScrollMagic';
import 'ScrollMagic.animation.gsap';
import 'ScrollMagic.debug.addIndicators';
import 'cycle2';
import 'cycle2-center';
import 'cycle2-swipe';


export default function page_progetti_singolo(app) {

    $(document).ready(function () {

        var topSlider = new Slider('topSlider', {
            autoresize: {
                enabled: false
            }
        }, {
            effect: 'fade',
            prevButton: '#top-slider-button-prev',
            nextButton: '#top-slider-button-next'
        });

        topSlider.render();
        app.topSlider = topSlider;

    });

}


/** WEBPACK FOOTER **
 ** ./assets/scripts/views/page_progetti_singolo.js
 **/